export interface ConfidentialityRecord extends Record<string, any> {
  miqProperties: {
    userConfidentiality: number;
  };
  confidentiality_f: number;
}

/**
 * Returns true if record confidentiality level is bigger than user confidentialities
 * from MIQ's properties
 *
 * @param record {ConfidentialityRecord}
 * @returns boolean
 * @example
 * const record = { miqProperties: { userConfidentiality: 1 }, confidentiality_f: 2 };
 * shouldDisable(record); // true
 */
export const shouldDisableByConfidentialityLevels = (record: ConfidentialityRecord): boolean => {
  const userConfidentiality = (record.miqProperties ?? {}).userConfidentiality;
  return record.confidentiality_f > userConfidentiality;
};
